import { render } from "./Questionario.vue?vue&type=template&id=c9e3a77e&scoped=true"
import script from "./Questionario.vue?vue&type=script&lang=js"
export * from "./Questionario.vue?vue&type=script&lang=js"

import "./Questionario.vue?vue&type=style&index=0&id=c9e3a77e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9e3a77e"]])

export default __exports__